import React from "react";
import { TableRowField } from "../../../../components";

export function dailyBalanceDetailXS() {
  return [
    {
      dataField: "xs",
      text: "Venta",
      formatter: (cell, row) => {
        let employees = [];
        for (const employee of row.Employees) {
          employees.push(employee.name + " " + employee.lastname);
        }
        const employeeNames = employees.join(", ");

        return (
          <div>
            {row.Offer ? (
              <TableRowField label="Ítem:" value={row.Offer.name} />
            ) : null}
            {row.Service ? (
              <TableRowField label="Ítem:" value={row.Service.name} />
            ) : null}
            {row.Product ? (
              <TableRowField label="Ítem:" value={row.Product.name} />
            ) : null}
            <TableRowField label="Empleados:" value={employeeNames} />
            <TableRowField label="Cantidad:" value={row.quantity} />
            <TableRowField label="Precio Total:" value={row.total_net} />
          </div>
        );
      },
    },
  ];
}

export function dailyBalanceDetail() {
  return [
    {
      dataField: "Content",
      text: "Ítem",
      formatter: (cell, row) => {
        row.Content = null;
        if (row.Offer) row.Content = row.Offer.name;
        if (row.Service) row.Content = row.Service.name;
        if (row.Product) row.Content = row.Product.name;
        return <span>{row.Content}</span>;
      },
    },
    {
      dataField: "Employees",
      text: "Empleados",
      formatter: (cell, row) => {
        if (row.Employees.length == 0) return <span>{"Sin Empleados"}</span>;
        let index = 0;
        for (const employee of row.Employees) {
          employee.id = index;
          index++;
        }
        return (
          <div>
            {row.Employees.map((employee) => (
              <div key={employee.id}>
                {" "}
                {employee.name + " " + employee.lastname}{" "}
              </div>
            ))}
          </div>
        );
      },
    },
    {
      dataField: "quantity",
      text: "Cantidad",
    },
    {
      dataField: "total_net",
      text: "Precio Total",
    },
  ];
}



// WEBPACK FOOTER //
// ./src/scenes/Report/Cash/DailyBalanceDetail/_columns.js